import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from '../pages/Login';
import Home from '../pages/Home';
import BusinessCard from '../pages/BusinessCard';
import SignUp from '../pages/SignUp';
import Profile from '../pages/Profile';
import EditProfile from '../pages/EditProfile';
import AvatarCustomization from '../pages/AvatarCustomization';
import AvatarStaging from '../pages/AvatarStaging'; // ✅ import this

export default function AppRouter({ isLoggedIn, setIsLoggedIn }) {
  const navigate = useNavigate();

  useEffect(() => {
    const storedStatus = localStorage.getItem("isLoggedIn");
    setIsLoggedIn(storedStatus === "true");

    const progress = localStorage.getItem("signupProgress");
    const token = localStorage.getItem("token");

    if (token && progress) {
      switch (progress) {
        case "businessCard":
          navigate("/BusinessCard");
          break;
        case "avatar":
          navigate("/avatar-customize");
          break;
        case "profile":
          navigate("/Profile");
          break;
        default:
          break;
      }
    }
  }, [navigate, setIsLoggedIn]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
      <Route path="/SignUp" element={<SignUp setIsLoggedIn={setIsLoggedIn} />} />
      <Route path="/BusinessCard" element={<BusinessCard />} />
      <Route path="/avatar-customize" element={<AvatarCustomization />} />
      <Route path="/avatar-staging" element={<AvatarStaging />} /> {/* ✅ new route */}
      <Route path="/Profile" element={isLoggedIn ? <Profile /> : <Navigate to="/login" replace />} />
      <Route path="/edit-profile" element={isLoggedIn ? <EditProfile /> : <Navigate to="/login" replace />} />
    </Routes>
  );
}
